/* ======================================================================
   URUN KARTI - DOKUNMATIK CIHAZDA "ORTADAKI KART ACILIR"
   ======================================================================

   Masaustunde bilgi hover ile aciliyor (CSS hallediyor). Telefonda hover
   diye bir sey yok; orada kullanici yatay seridi kaydirirken EKRANIN
   ORTASINA gelen kart kendiliginden acilir, digerleri kapanir.

   Neden IntersectionObserver degil de scroll dinleyici?
   IntersectionObserver "gorunuyor mu" sorusunu cevaplar; burada gereken
   "hangisi ortaya EN YAKIN" - bu bir siralama sorusu. Ama olcumu her
   scroll olayinda degil, requestAnimationFrame ile karede bir yapiyoruz;
   boylece kaydirma akiciligi bozulmuyor.

   Serit DISINDAKI kartlarda (koleksiyon izgarasi gibi) dokunmatikte
   ortalama mantigi anlamsiz kalir - orada bilgi hep acik birakilir.
   ====================================================================== */

(function () {
  'use strict';

  var isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;
  if (!isTouch) return;

  var CARD = '.product--card-inner.has-hover-reveal';

  // Yatay kaydirilan serit kaplari. Bunlarin ICINDEKI kartlar "ortadaki
  // acilir" mantigina girer; disindakiler hep acik kalir.
  var TRACK =
    'scroll-carousel, .swiper-wrapper, .product-list--carousel, [data-card-track]';

  function isInTrack(card) {
    return !!card.closest(TRACK);
  }

  // Serit disindaki kartlar: dokunmatikte acilip kapanacak bir tetik yok,
  // bilgiyi gizli birakmak onlari erisilemez yapardi.
  function markAlwaysOpen() {
    document.querySelectorAll(CARD).forEach(function (card) {
      if (!isInTrack(card)) card.classList.add('card-reveal-always');
    });
  }

  var ticking = false;

  function update() {
    ticking = false;

    var viewportCenter = window.innerHeight / 2;
    var tracks = document.querySelectorAll(TRACK);

    tracks.forEach(function (track) {
      var cards = track.querySelectorAll(CARD);
      if (!cards.length) return;

      // Yatay seritte "orta" yatay eksende, dikey listede dikey eksende
      // olculur. Seridin kendi genisligi/yuksekligi bunu belli eder.
      var trackRect = track.getBoundingClientRect();
      var horizontal = track.scrollWidth > track.clientWidth + 4;

      var best = null;
      var bestDistance = Infinity;

      cards.forEach(function (card) {
        var r = card.getBoundingClientRect();

        // Ekranin tamamen disindaki karti hesaba katma.
        if (r.bottom < 0 || r.top > window.innerHeight) return;

        var distance;
        if (horizontal) {
          var trackCenter = trackRect.left + trackRect.width / 2;
          distance = Math.abs(r.left + r.width / 2 - trackCenter);
        } else {
          distance = Math.abs(r.top + r.height / 2 - viewportCenter);
        }

        if (distance < bestDistance) {
          bestDistance = distance;
          best = card;
        }
      });

      cards.forEach(function (card) {
        card.classList.toggle('is-centered', card === best);
      });
    });
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  function init() {
    markAlwaysOpen();
    requestUpdate();

    // Serit kendi icinde kaydigi icin scroll'u yakalamak adina passive +
    // capture kullaniyoruz: capture olmadan ic kaplarin scroll olaylari
    // window'a kadar cikmaz.
    window.addEventListener('scroll', requestUpdate, { passive: true, capture: true });
    window.addEventListener('resize', requestUpdate, { passive: true });

    // Bolumler editorde yeniden yuklendiginde veya urunler sonradan
    // eklendiginde (sonsuz kaydirma) yeni kartlari da kapsa.
    document.addEventListener('shopify:section:load', function () {
      markAlwaysOpen();
      requestUpdate();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
